import cssConstants from './styles/constants';

const Styles = {
  ...cssConstants,
};

const _global = typeof window === 'undefined' ? global : window;
//@ts-ignore-next-line
_global.Styles = Styles;

(globalThis as any).Styles = Styles;
